import { useInfiniteQuery } from "@tanstack/react-query";
import { useReploAgent } from "@v2/contexts/ReploAgentContext";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";

const PAGE_SIZE = 20;

export const GIT_HISTORY_QUERY_KEY = "gitHistory";

export function useGitHistory() {
  const {
    actions: { getGitHistory },
  } = useReploAgent();
  const projectId = useCurrentProjectId();

  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [GIT_HISTORY_QUERY_KEY, projectId],
      queryFn: ({ pageParam }) => {
        return getGitHistory({ limit: PAGE_SIZE, skip: pageParam });
      },
      getNextPageParam: (lastPage, allPages) => {
        if (!lastPage.hasMore) {
          return undefined;
        }
        return allPages.reduce((sum, p) => sum + p.commits.length, 0);
      },
      initialPageParam: 0,
    });

  return {
    commits: data?.pages.flatMap((p) => p.commits) ?? [],
    isLoading,
    isFetchingMore: isFetchingNextPage,
    hasMore: hasNextPage ?? false,
    fetchMore: fetchNextPage,
  };
}
